module.exports = __webpack_public_path__ + "static/media/Yuvi.86dad789.png";